import * as React from 'react';

import { Image } from './careers-benefits-stripes1.styles';

export const Stripes1View = ({ imageSrc }) => <Image src={imageSrc} alt="" />;
